module.exports = __webpack_public_path__ + "img/iconDrawer.2622dd05.svg";